<template>
  <ContentPage>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">W9 Request</div>
    </template>

    <Section class="d-flex flex-column" style="overflow-x: hidden">
      <v-icon size="96" color="primary">mdi-check-circle-outline</v-icon>      
      <div 
        style="font-size: 24px;" 
        class="text-center black--text font-weight-bold mt-2"
      >
        Thank You!
      </div>
      <div class="black--text mt-3">
        It may take up to 24 hours for your business's W-9 be accepted. Please
        remember to fill out a new W-9 if you have a name or address change.
        You can submit a new form at any time from your profile page.
      </div>
      <div class="my-4 d-flex justify-center">
        <v-btn color="primary" :to="{ name: 'referrals' }">Done</v-btn>
      </div>
    </Section>
  </ContentPage>
</template>

<script>

import { ContentPage, Section } from '@/components/pages'

export default {
  name: 'W9ThanksPage',

  components: { ContentPage, Section },

  data: () => ({
    certified: false,
    cert_open: false,
    
    is_certified: v => v || 'You must certify to continue'
  }),

  computed: {
    cert_style() {
      if (!this.cert_open) {
        return { 
          'font-size': '12px',
          'overflow-y': 'clip',
          'max-height': '135px'
        }
      } else {
        return { 'font-size': '12px' }
      }
    },
  },

  methods: {
    nextClick() {
      if (this.$refs.form.validate()) {
        this.$router.push({ name: 'w9/form' })
      }
    }
  }
}
</script>